import {
  FleetVehicleExpenseEditFormValues,
  FleetVehicleExpenseSearchFormValues,
} from "./types";

export const initialFleetVehicleExpenseSearchForm: FleetVehicleExpenseSearchFormValues =
  {
    search: "",
    expenseTypeId: null,
    expenseDateFrom: null,
    expenseDateTo: null,
    amountMin: null,
    amountMax: null,
    vehicleManufacturerId: null,
    vehicleModelId: null,
    vehicleTypeId: null,
  };

/** Vrsta troška koju predlaže čarobnjak premještaja — sistemska podgrupa „Transport vozila". */
export const EXPENSE_TYPE_VEHICLE_TRANSPORT = "3c05a1d0-0002-4c00-9a00-000000000010";

/**
 * Ikona po šifri vrste troška — vrste dolaze iz šifrarnika (naziv i šifra), a ovdje im se dodaje
 * ono što šifrarnik ne nosi, da se u popisu prepoznaju na prvi pogled. Nepoznata vrsta dobiva
 * zadanu ikonu.
 */
export const EXPENSE_TYPE_ICONS: Record<string, string> = {
  "FLEET-TRANS": "/media/icons/location.svg",
  "FLEET-SERVIS": "/media/icons/service.svg",
  "FLEET-GUME": "/media/icons/tire.svg",
  "FLEET-OSIG": "/media/icons/shield.svg",
  "FLEET-REG": "/media/icons/list-check.svg",
  "FLEET-OPREMA": "/media/icons/fire-extinguisher.svg",
  "FLEET-NABAVA": "/media/icons/vehicle.svg",
  "FLEET-NABAVA-POREZ": "/media/icons/finance.svg",
  "FLEET-GORIVO": "/media/icons/payment.svg",
  "FIN-KAMATE": "/media/icons/bank.svg",
  "OTHER-AMORT": "/media/icons/price.svg",
};

export const DEFAULT_EXPENSE_TYPE_ICON = "/media/icons/expense.svg";

/**
 * Kratki opis po šifri vrste troška, za kartice pri odabiru vrste. Šifrarnik nosi samo naziv,
 * pa se ovdje objašnjava što koja vrsta obuhvaća.
 */
export const EXPENSE_TYPE_DESCRIPTIONS: Record<string, string> = {
  "FLEET-NABAVA": "Kupnja vozila za vozni park",
  "FLEET-SERVIS": "Redovni servis, popravci i dijelovi",
  "FLEET-GUME": "Nabava, zamjena i skladištenje guma",
  "FLEET-REG": "Registracija, tehnički pregled i naknade",
  "FLEET-OSIG": "Obvezno osiguranje i kasko vozila",
  "FLEET-GORIVO": "Gorivo i punjenje električnih vozila",
  "FLEET-CEST": "Cestarine, vinjete i parkiranje",
  "FLEET-KAZNE": "Prometne i parkirne kazne",
  "FLEET-PRANJE": "Pranje, čišćenje i priprema za prodaju",
  "FLEET-TRANS": "Prijevoz vozila šleperom ili vozačem",
  "FLEET-NABAVA-POREZ": "PPMV, carina i naknade pri kupnji",
  "FLEET-OPREMA": "Obvezna i dodatna oprema vozila",
  "SALES-OGLAS": "Oglasi na portalima i promocija vozila",
  "SALES-PROV": "Provizije prodajnog osoblja",
  "SALES-JAMST": "Troškovi jamstva i reklamacija kupaca",
  "SALES-POSR": "Naknade posrednicima pri prodaji",
  "RENT-AGENC": "Provizije agencija i portala za najam",
  "RENT-SUSTAV": "Pretplate na rezervacijske sustave",
  "RENT-STETA": "Dio štete koji polica ne pokriva",
  "RENT-ZAMJ": "Najam zamjenskog vozila za klijenta",
  "FACIL-NAJAM": "Najamnina poslovnog prostora",
  "FACIL-REZIJE": "Računi za struju, plin i vodu",
  "FACIL-KOM": "Komunalna naknada i odvoz otpada",
  "FACIL-ODRZ": "Popravci i održavanje prostora",
  "ADMIN-PLACE": "Plaće, doprinosi i naknade zaposlenima",
  "ADMIN-KNJIG": "Usluge knjigovodstva i revizije",
  "ADMIN-PRAVO": "Odvjetničke i javnobilježničke usluge",
  "ADMIN-URED": "Uredski materijal i potrepštine",
  "ADMIN-TELE": "Mobilne, fiksne i internetske usluge",
  "ADMIN-IT": "Softver, licence i IT oprema",
  "MKT-OGLAS": "Oglašavanje tvrtke i brenda",
  "MKT-WEB": "Web stranica i društvene mreže",
  "MKT-SPONZ": "Sponzorstva, donacije i poklon paketi",
  "FIN-BANKA": "Bankovne naknade i provizije",
  "FIN-KAMATE": "Kamate na kredite i troškovi leasinga",
  "FIN-TECAJ": "Negativne tečajne razlike",
  "FIN-OSIG": "Osiguranje imovine i odgovornosti tvrtke",
  "OTHER-REPR": "Poslovni ručkovi i reprezentacija",
  "OTHER-EDU": "Tečajevi, seminari i edukacija",
  "OTHER-AMORT": "Amortizacija vozila i opreme",
  "OTHER-NERAZ": "Trošak koji ne pripada nijednoj vrsti",
};

export const initialFleetVehicleExpenseEditForm: FleetVehicleExpenseEditFormValues =
  {
    id: "",
    vehicleId: "",
    expenseTypeId: null,
    officeId: null,
    name: "",
    description: "",
    expenseDate: null,
    paymentDate: null,
    amount: null,
    taxAmount: null,
    files: [],
  };
